import WalletIcon from '@mui/icons-material/Wallet';
import Button from 'components/Button';
import { Divider } from 'components/Snomed/styles';
import { ModalCloseButton, ModalCloseIcon, MuiModal } from 'components/TemplateManager/ModalStyles';
import { STRINGS } from 'config';
import { useEffect, useState } from 'react';
import { getOrdersPage } from 'store/action/wallet';
import { useAppDispatch, useAppState } from 'store/configureStore';
import { hasUnlimitedSub } from 'store/reducer/wallet';
import { SELECTED_PRODUCT_CHOICE } from '../freeTimer';
import Balance from './balance';
import { OrderTable } from './orderTable';

const {
  REDUCERS: {
    WALLET: { SET_SHOW_DAY_PASS_FLAG },
  },
} = STRINGS;

const Wallet = () => {
  const {
    wallet: { topup, shouldShowDayPassFlag, passes, subscription },
    app: { selectedPractice },
  } = useAppState();

  const selectedPracticeId = selectedPractice?.id;
  const [showOrdersModal, setShowOrdersModal] = useState(false);
  const dispatch = useAppDispatch();
  useEffect(() => {
    async function fetchOrders() {
      if (selectedPracticeId) {
        return getOrdersPage(1, selectedPracticeId);
      }
      return null;
    }

    const getWasDayPassBought = sessionStorage.getItem(SELECTED_PRODUCT_CHOICE);
    if (shouldShowDayPassFlag && getWasDayPassBought === 'DAY_PASS') {
      (async () => {
        await fetchOrders();
        setShowOrdersModal(true);
        sessionStorage.setItem(SELECTED_PRODUCT_CHOICE, 'NONE');
      })();
    }
    return () => {};
  }, [shouldShowDayPassFlag, selectedPracticeId]);

  if (topup === null || hasUnlimitedSub(subscription)) {
    return null;
  }

  return (
    <div style={{ marginLeft: '16px' }}>
      <Button
        onClick={() => {
          dispatch({ type: SET_SHOW_DAY_PASS_FLAG, payload: false });
          setShowOrdersModal(true);
        }}
        id="wallet--button"
        buttonText="View wallet"
        disabled={false}
        state="secondary"
        icon={<WalletIcon />}
        iconPosition="left"
        className=""
        style={{ height: '28px' }}
      />
      <MuiModal
        open={showOrdersModal}
        onClose={() => setShowOrdersModal(false)}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '16px',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
        }}
      >
        <div
          style={{
            backgroundColor: 'white',
            padding: '24px',
            borderRadius: '12px',
            maxWidth: '800px',
            width: '100%',
            maxHeight: '90vh',
            overflow: 'auto',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
          }}
        >
          <div
            style={{
              display: 'flex',
              flex: 1,
              justifyContent: 'flex-end',
              alignItems: 'flex-start',
            }}
          >
            <ModalCloseButton
              data-automation="ModalCloseButton-wallet"
              type="button"
              tabIndex={0}
              onClick={() => setShowOrdersModal(false)}
            >
              <ModalCloseIcon />
            </ModalCloseButton>
          </div>
          <Balance
            freeBalanceSeconds={topup.freeBalanceSeconds || 0}
            paidBalanceSeconds={topup.paidBalanceSeconds || 0}
            totalUsableSeconds={topup.totalUsableSeconds || 0}
            passes={passes}
            selectedPracticeId={selectedPracticeId}
          />
          <Divider />
          <OrderTable />
        </div>
      </MuiModal>
    </div>
  );
};

export default Wallet;
